import React from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { getDecisionColor } from "../../utils/codingOpStorage";

export default function CodingOpsTable({ rows, loading }) {
  return (
    <Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><b>HCC</b></TableCell>
              <TableCell><b>Diagnosis</b></TableCell>
              <TableCell><b>Year</b></TableCell>
              <TableCell><b>Status</b></TableCell>
              <TableCell><b>Last DOS</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CircularProgress size={18} />
                    <Typography variant="body2">Loading opportunities...</Typography>
                  </Stack>
                </TableCell>
              </TableRow>
            ) : null}

            {!loading && (!rows || rows.length === 0) ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography variant="body2" color="text.secondary">
                    No opportunities for this patient.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : null}

            {!loading &&
              (rows || []).map((r) => (
                <TableRow key={r.codingOpportunityId} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={700}>
                      {r.hccId || "-"}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {r.hccDescription || ""}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {r.diagnosisCode || "-"} {r.diagnosisDescription ? `- ${r.diagnosisDescription}` : ""}
                    </Typography>
                  </TableCell>

                  <TableCell>{r.measureYear ?? "-"}</TableCell>

                  <TableCell>
                    <Chip
                      label={r.statusName || r.status || "-"}
                      size="small"
                      color={getDecisionColor(r.statusName || r.status)}
                    />
                  </TableCell>

                  <TableCell>{r.lastDos || ""}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
